export default __webpack_public_path__ + "static/matcha@2x-5707f15ed1a133fab1e093397586879c.png";